import JChartPie from './Control_Charts'
export { JChartPie }
export default JChartPie